<ng-container *transloco="let t; read: 'settings-row-slide-component'">
  <xi-toggle-switch
    color="CX"
    [isToggled]="value()"
    [leftText]="t('off')"
    [rightText]="t('on')"
    [disabled]="disabled() || !hasPermission()"
    (onToggle)="valueChange.emit($event.detail.isToggled)"
    [label]="label()"
  ></xi-toggle-switch>

  @if (!hasPermission()) {
    <a
      href="https://www.lexalytics.com/contact"
      target="_blank"
      class="configuration-settings__row-link--unavailable"
      >{{ t('contact-support') }}</a
    >
  }
</ng-container>
